import script from "./NeetsFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./NeetsFilter.vue?vue&type=script&setup=true&lang=js"

import "./NeetsFilter.vue?vue&type=style&index=0&id=0264c005&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0264c005"]])

export default __exports__